import { fabric } from 'fabric';
import $ from 'jquery';
import imageHelpers from '@/helpers/image';
import SelectionStyle from './components/SelectionStyle.vue';
import { personalizesApi } from '@/apis/personalizes';
import { uploadService } from '@/apis/upload.s';
import axios from 'axios';
import { formatDataPersonalized } from '@/helpers/formatDataPersonalized';
// var FontFaceObserver = require('fontfaceobserver');

export default {
  components: { SelectionStyle },
  data() {
    let defaultSetting = {
      align: 'center',
      bold: false,
      fontColor: '#000000',
      fontSize: '25px',
      italic: false,
      underline: false,
      fontFamily: 'Arial',
      effect: 'STRAIGHT',
      caps: false,

      text: 'Your custom',
      bodyHtml: '',
      placeholder: '',
      required: true,
      maxLength: 30,
      type: 'textbox',

      validations: {
        allowed_characters: ['characters', 'numbers'],
        max_length: 30,
        required: true,
      },
    };
    return {
      isChangeOption: false,
      isAdd: true,
      fonts: [],
      e1: 1,
      imageHelpers,
      itemPresonal: null,
      canvas: {
        product: null,
        preview: null,
      },
      optionsProductSetting: { ...defaultSetting },
      optionsPreviewSetting: { ...defaultSetting },
      defaultSetting,
      overlay: false,
      formData: {
        previewSvg: null,
        productionSvg: null,
        previewJson: null,
        previewAttributes: [],
        productionJson: null,
        productAttributes: [],
      },
      imageUrl: {
        product: null,
        preview: null,
      },

      image: {
        src: null,
        size: {
          width: 0,
          height: 0,
        },
      },

      isLoading: false,
      isLoadingStyle: false,
      maxWidth: 0,
      listFontSize: [],
      previewSetting: {
        product: null,
      },
      loadFCV: null,
      hasImageObject: false,
      showCustomizeWindow: false,
      canvasSettings: {
        width: 0,
        height: 0,
      },
    };
  },
  async created() {
    for (let i = 11; i < 60; i++) {
      this.listFontSize.push({ name: `${i}px`, id: i });
    }
  },
  methods: {
    async getFontPersonalize() {
      try {
        this.fonts = (await personalizesApi.getFont()).data.map(item => {
          return {
            ...item,
            name: item.name === 'Lobster 1.3' ? 'Lobster' : item.name,
          };
        });
        for (let index = 0; index < this.fonts.length; index++) {
          const element = this.fonts[index];
          $('head').append(
            `<style type='text/css'>@font-face { font-family: '${element.name}' ; src: url(${element.fontUrl}); }</style>`,
          );
          let text = new fabric.Textbox('A', {
            fontFamily: element.name,
          });
          this.loadFCV.add(text);
          this.loadFCV.renderAll();
        }
      } catch (error) {
        console.log(error, 'error');
      }
    },
    clickUploadFile() {
      this.resetImageUploader();
      this.$refs.fileUploader.click();
    },
    resetImageUploader() {
      this.$refs.fileUploader.value = '';
    },
    stepSetupProduct() {
      this.e1 = 2;
      console.log('check data', this.canvas.product.toSVG());
      this.formData.productionSvg = formatDataPersonalized(this.canvas.product.toSVG());
      let objects = this.canvas.product.getObjects();
      let attributes = [];
      for (let i = 0; i < objects.length; i++) {
        let obj = objects[i];
        let custom = {
          ...obj.custom,
        };
        let objJson = JSON.stringify(obj);
        let fullObject = JSON.parse(objJson);

        attributes.push({
          ...fullObject,
          ...custom,
          canvasWidth: this.canvasSettings.width,
          canvasHeight: this.canvasSettings.height,
        });
      }
      this.formData.productAttributes = attributes;
      this.formData.productionJson = this.canvas.product.toDatalessJSON();
      this.stepSetupPreview();
    },
    stepSetupPreview() {
      let parser = new DOMParser();
      let xmlDocProduct = this.formData.productionSvg
        ? parser.parseFromString(this.formData.productionSvg, 'text/xml')
        : null;

      if (xmlDocProduct && xmlDocProduct.querySelector('image')) {
        xmlDocProduct.querySelector('svg').setAttribute('width', '100%');
        xmlDocProduct.querySelector('svg').setAttribute('height', '100%');
        let attributes = xmlDocProduct.querySelector('image').attributes;
        document.querySelector('.personalize-production').style.width = parseFloat(attributes.width.value) + `px`;
        document.querySelector('.personalize-production').innerHTML = xmlDocProduct.querySelector('svg').outerHTML;
      }
    },
    removeStringXML(string) {
      let newSvg;
      let indexTagSVg = string.search('<svg xmlns');
      newSvg = string.substring(indexTagSVg);
      return newSvg;
    },
    checkFonts() {
      let type = ['product', 'preview'];
      let fontsCanvas = [];
      for (let i = 0; i < type.length; i++) {
        let obj =
          this.canvas[type[i]] && this.canvas[type[i]].toDatalessJSON() ? this.canvas[type[i]].toDatalessJSON() : null;
        if (obj) {
          for (let i = 0; i < obj.objects.length; i++) {
            fontsCanvas.push(obj.objects[i].fontFamily);
          }
        }
      }
      return this.fonts.filter(item => fontsCanvas.includes(item.name));
    },
    async submit() {
      try {
        this.isLoading = true;
        await personalizesApi.create({
          productId: this.$route.params.id,
          productionSvg: this.removeStringXML(this.formData.productionSvg),
          createdById: this.$store.state.auth.user.id,
          fonts: this.checkFonts(),
          productionJson: JSON.stringify(this.formData.productionJson),
          countTexts: this.formData.productionJson?.objects?.filter(item => item.type == 'textbox').length,
          productAttributes: this.formData.productAttributes,
        });
        this.$router.push({ name: 'website.product-personalized' });
        // this.$router.push({
        //   name: 'website.product-personalized.detail',
        //   params: {
        //     id: this.itemPresonal.id,
        //   },
        // });
      } catch (error) {
        console.log(error, 'error');
      }
      this.isLoading = false;
    },
    changeFsProductSetting(options, type) {
      try {
        let activeObject =
          this.canvas[type] && this.canvas[type].getActiveObject() ? this.canvas[type].getActiveObject() : null;
        if (activeObject && !this.isAdd) {
          if (activeObject.custom?.type === 'textbox') {
            activeObject.set('fontFamily', options.fontFamily);
            activeObject.set('fontSize', parseInt(options.fontSize.substring(0, options.fontSize.length - 2)));
            activeObject.set('fontWeight', options.bold ? 'bold' : ''); //normal  //bold
            activeObject.set('underline', options.underline);
            activeObject.set('textAlign', options.align);
            activeObject.set('fontStyle', options.italic ? 'italic' : '');
            activeObject.set('effect', options.effect);
            activeObject.set('fill', options.fontColor);
            activeObject.set('styles', options.caps ? 'uppercase' : '');
            activeObject.set('text', !options.caps ? options.text : options.text.toUpperCase());
            activeObject.set('textLines', [options.text]);
            activeObject.set('maxLength', options.maxLength);

            activeObject.set('custom', {
              bodyHtml: options.bodyHtml,
              placeholder: options.placeholder,
              required: options.required,
              type: activeObject.custom?.type,
              maxLength: options.maxLength,
              validations: {
                ...options.validations,
                max_length: parseInt(options.maxLength),
                required: options.required,
              },
            });
            this.canvas[type].renderAll();
            this.isChangeOption = false;
          } else if (activeObject.custom?.type === 'image') {
            activeObject.set('custom', {
              bodyHtml: options.bodyHtml || '',
              placeholder: options.placeholder || '',
              required: options.required || false,
              type: activeObject.custom?.type,
              maxLength: options.maxLength || 30,
              validations: {
                ...options.validations,
                max_length: parseInt(options.maxLength || '30'),
                required: options.required || false,
              },
            });
            this.canvas[type].renderAll();
            this.isChangeOption = false;
          }
        }
        this.isAdd = false;
      } catch (error) {
        console.log(error, 'error');
      }
    },
    addText(type) {
      this.isAdd = true;
      let text = new fabric.Textbox(this.defaultSetting.text, {
        width: 100,
        fontSize: 25,
        textAlign: 'center',
        originX: 'center',
        originY: 'center',
        fontFamily: 'Arial',
        id: `per_text_${this.canvas[type].getObjects().length}`,
        maxLength: this.defaultSetting.maxLength,
      });

      text.custom = {
        bodyHtml: 'Your custom',
        placeholder: 'placeholder',
        required: true,
        type: 'textbox',
        validations: {
          allowed_characters: this.defaultSetting.validations.allowed_characters,
          max_length: this.defaultSetting.maxLength,
          required: this.defaultSetting.required,
        },
      };
      this.canvas[type].discardActiveObject();
      this.canvas[type].add(text);
      this.canvas[type].centerObject(text);
      text.setCoords();
      text.setControlsVisibility({});
      this.canvas[type].setActiveObject(text);
      this.canvas[type].renderAll();
      this.optionsProductSetting = { ...this.defaultSetting };
      this.optionsPreviewSetting = { ...this.defaultSetting };
      this.$forceUpdate();
    },
    addImage(type) {
      this.overlay = true;
      let imgURL = 'http://i.imgur.com/8rmMZI3.jpg';
      let yourImage = new Image();
      let vm = this;
      yourImage.onload = function(img) {
        let pug = new fabric.Image(yourImage, {
          width: 500,
          height: 500,
          left: 50,
          top: 70,
          scaleX: 0.25,
          scaleY: 0.25,
        });

        pug.custom = {
          bodyHtml: 'Your image',
          placeholder: 'placeholder',
          required: true,
          type: 'image',
          validations: {
            required: vm.defaultSetting.required,
          },
        };

        vm.canvas[type].discardActiveObject();
        vm.canvas[type].add(pug);
        vm.canvas[type].centerObject(pug);
        pug.setCoords();
        pug.setControlsVisibility({});
        vm.canvas[type].setActiveObject(pug);
        vm.canvas[type].renderAll();
        vm.$forceUpdate();
        vm.overlay = false;
      };
      yourImage.src = imgURL;
    },
    getDataStyle(data, type) {
      this.changeFsProductSetting(data, type);
    },
    uploadImagePreview(e) {
      this.handleUploadImage(e, 'preview');
    },
    checkAspect(size) {
      if (size.width < this.maxWidth) {
        return 1;
      }
      if (size.width > 2 * this.maxWidth) {
        return 0.25;
      } else return 0.5;
    },
    async handleUploadImage(e, type) {
      var file = e.target.files[0];
      if (file) {
        var img = new Image();
        let vm = this;
        let size = { width: 600, height: 600 };
        this.overlay = true;

        img.onload = async function() {
          size = { width: img.width, height: img.height };
          let per = vm.checkAspect(size);
          var f_img = new fabric.Image(img);
          vm.myEventHandler(size, type, per);
          vm.canvas[type].setBackgroundImage(f_img, vm.canvas[type].renderAll.bind(vm.canvas[type]), {
            scaleX: per,
            scaleY: per,
          });
          vm.canvas[type].renderAll();
          vm.overlay = false;
          vm.resetImageUploader();
        };

        let uploadImage = await this.onChangeImage(e);
        if (uploadImage) {
          img.src = '';
          this.imageUrl[type] = this.imageHelpers.url(uploadImage.src, size);
          img.src = this.imageUrl[type];
        } else {
          this.overlay = false;
        }

        this.hasImageObject = true;
      } else {
        this.hasImageObject = false;
      }
    },
    async uploadImageProduct(e, type) {
      this.handleUploadImage(e, 'product');
    },
    myEventHandler(size, type, per) {
      let percent = per ? per : 0.5;
      let w = size ? `${size.width * percent}px` : `500px`;
      let h = size ? `${size.height * percent}px` : `500px`;
      this.canvas[type].setDimensions({ width: size.width * percent, height: size.height * percent });
      if (type === 'product') {
        this.canvasSettings = {
          width: size.width * percent,
          height: size.height * percent,
        };
        $('#cp')
          .css('width', w)
          .css('height', h);
        $('#cpp')
          .css('width', w)
          .css('height', h);
      } else {
        $('#cpr')
          .css('width', w)
          .css('height', h);
        $('#cprp')
          .css('width', w)
          .css('height', h);
      }

      $(`.${type}-canvas .canvas-container `)
        .css('width', w)
        .css('height', h);
      $(`.${type}-canvas .upper-canvas`)
        .css('width', w)
        .css('height', h);
    },
    refresh() {
      location.reload();
    },
    deleteSelection(type) {
      var activeGroup = this.canvas[type].getActiveObject();
      this.canvas[type].remove(activeGroup);
      this.optionsProductSetting = this.defaultSetting;
      this.optionsPreviewSetting = this.defaultSetting;
      this.showCustomizeWindow = false;
    },
    objectId() {
      return this.hex(Date.now() / 1000) + ' '.repeat(16).replace(/./g, () => this.hex(Math.random() * 16));
    },
    hex(value) {
      return Math.floor(value).toString(16);
    },
    async onChangeImage(e) {
      let inputTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/jpg'];
      if (inputTypes.includes(e.target.files[0].type)) {
        let file = e.target.files[0];
        try {
          let type = file.name.split('.')[file.name.split('.').length - 1];
          let id = this.objectId();
          let urlData = await uploadService.get({ filename: `image-${id}.${type}` });
          if (urlData) {
            let res = await axios.put(urlData.data.presignedUrl, file, {
              headers: {
                'Content-Type': `${file.type}`,
              },
            });
            let obj = {
              alt: file.name,
              alt_text: file.name,
              src: urlData.data.imagePath,
              _id: id,
            };
            return obj;
          }
        } catch (error) {
          this.$store.commit('setMessages', {
            messages: 'Error image ',
            type: 'error',
          });
        }
      } else {
        return false;
      }
    },
  },
};
